import { Card, CardContent, Grid, Tooltip, Typography } from "@mui/material";
import { ISidekickStats } from "../../types/api/sidekick-usage.type";
import { formatCount, formatLatency } from "./labels";

interface Tile {
  label: string;
  value: string;
  help: string;
}

const buildTiles = (stats: ISidekickStats): Tile[] => [
  { label: "Questions asked", value: formatCount(stats.turns), help: "Every question sent to Sidekick in this view." },
  { label: "Conversations", value: formatCount(stats.sessions), help: "Chat sessions. One conversation can hold several questions." },
  { label: "People", value: formatCount(stats.users), help: "Distinct people who asked at least one question." },
  { label: "Questions from customers", value: formatCount(stats.customer_turns), help: "Questions asked by people outside ControlRooms." },
  { label: "Typical response time", value: formatLatency(stats.median_latency_ms), help: "Median time Sidekick took to answer." },
  { label: "Rated answers", value: formatCount(stats.rated), help: "Answers that got a thumbs up or thumbs down." },
  { label: "Thumbs down", value: formatCount(stats.thumbs_down), help: "Answers the asker marked as unhelpful." },
  { label: "Ran out of tool budget", value: formatCount(stats.budget_exceeded), help: "Sidekick hit its limit on lookups before finishing; the answer may be incomplete." },
  { label: "Answer guard warnings", value: formatCount(stats.answer_guards), help: "Answers where an automatic check flagged a possible problem." },
  { label: "From the iPhone app", value: formatCount(stats.ios_turns), help: "Questions asked from the iPhone app rather than the web." },
];

const StatsTiles = ({ stats }: { stats: ISidekickStats }) => (
  <Grid container spacing={2}>
    {buildTiles(stats).map((tile) => (
      <Grid item xs={6} sm={4} md={3} lg={12 / 5} key={tile.label}>
        <Tooltip title={tile.help} placement="top">
          <Card sx={{ backgroundColor: "#18191D", boxShadow: "none", height: "100%" }} data-testid="stat-tile">
            <CardContent sx={{ pb: "16px !important" }}>
              <Typography variant="body2" color="#999">
                {tile.label}
              </Typography>
              <Typography variant="h5">{tile.value}</Typography>
            </CardContent>
          </Card>
        </Tooltip>
      </Grid>
    ))}
  </Grid>
);

export default StatsTiles;
